import React, { useEffect, useMemo, useState, useRef } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"
//import components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import toastr from "toastr"
import axios from "../../axios"
import Select from "react-select"
import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
} from "reactstrap"
import { makeStyles } from "@material-ui/core/styles"
import DeleteModal from "../../components/Common/DeleteModal"
import SweetAlert from "react-bootstrap-sweetalert"
import { Dialog, DialogTitle } from "@material-ui/core"
import Backdrop from "@material-ui/core/Backdrop"
import Spinner from "react-spinkit"
const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}))

function DatatableTables() {
  const [modal, setModal] = useState(false)
  // const [modal1, setModal1] = useState(false);
  const [isEdit, setIsEdit] = useState(false)
  const classes = useStyles()
  const [userList, setUserList] = useState([])
  const [user, setUser] = useState([])
  const [duplicateerro, setduplicateerro] = useState(false)
  const [coutrysuccess, setcoutrysuccess] = useState(false)
  const [countryerror, setcountryerror] = useState(false)
  const [countryinfo, setcountryinfo] = useState(false)
  const [deletid, setdeletid] = useState("")
  const [tokent, settokent] = useState(
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ"
  )
  const [allcategorycollections, setallcategorycollections] = useState([])
  const [allproductscollection, setallproductscollection] = useState([])
  const [categrid, setcategrid] = useState("")
  const [categoryfilter, setcategoryfilter] = useState([])
  const categoryref = useRef("")
  const [open, setopen] = useState(false)
  const [uomError, setuomError] = useState(false)
  const [categorydefaultvalue, setcategorydefaultvalue] = useState({
    label: "Select...",
    value: "",
  })
  const [proid, setproid] = useState("")
  const [categoryerror, setcategoryerror] = useState(false)
  const [secondaryuomerror, setsecondaryuomerror] = useState(false)
  const [priuomderror, setpriuomderror] = useState(false)
  const [buyerattcheload, setbuyerattcheload] = useState({ Image: "" })
  const [imageError, setImageError] = useState("")
  const [buyerattchenamte, setbuyerattchenamte] = useState("")
  const [buyerattch, setbuyerattch] = useState(null)
  const [branderror, setbranderror] = useState(false)
  const [Poupuimage, setPoupuimage] = useState("")
  const [dialogbox, setdialogbox] = useState(false)
  const [prodimages, setprodimages] = useState("")
  const [allproductslists, setallproductslists] = useState({
    Product_Details_Description: "",
    Product_Details_Code: "",
    Rate: "",
    UOM: "",
    Image: "",
    Active: true,
  })

  const BuyerAttchepack = async e => {
    const file = e.target.files[0]
    if (file) {
      setbuyerattcheload(file)
      const filereader = new FileReader()
      filereader.readAsDataURL(file)
      filereader.onload = renderevent => {
        setprodimages(file)
        setbuyerattch(renderevent.target.result)
        setbuyerattchenamte(file.name)
      }
      setImageError("")
    }
  }

  // validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...allproductslists,
    },
    validationSchema: Yup.object({
      Product_Details_Description: Yup.string()
        .max(50, "Description Must Be Atmost 100 Characters")
        .required("Please Enter Description"),
      Product_Details_Code: Yup.string().max(15),
      Rate: Yup.string().max(15),
      UOM: Yup.string()
        .max(10, "UOM Must Be Atmost 10 Characters")
        .required("Please Enter UOM"),
    }),
    onSubmit: async values => {
      console.log(
        "Result one",
        !buyerattcheload,
        "Result Two",
        !buyerattcheload.name
      )
      // Manual image validation

      if (!buyerattcheload || (!isEdit && !buyerattcheload.name)) {
        setImageError("Please upload a product image")
        return
      } else {
        setImageError("")
      }

      const formdata = new FormData()
      formdata.append(
        "Product_Details_Description",
        values.Product_Details_Description
      )
      formdata.append("Product_Details_Code", values.Product_Details_Code)
      formdata.append("Category_Id", categrid)
      formdata.append("Rate", values.Rate)
      formdata.append("UOM", values.UOM)
      formdata.append("Active", values.Active ? "Y" : "N")
      formdata.append("Image", buyerattcheload)

      if (isEdit) {
        formdata.append("Modify_By", localStorage.getItem("UserId"))
        formdata.append("Modify_Date", new Date())
        formdata.append("Product_Details_Id", proid)

        const update = await axios.instance
          .put(`/Updateproduct`, formdata, {
            headers: {
              Authorization: tokent,
              "Content-Type": "application/json",
            },
          })
          .then(res => {
            if (res.data === "") {
              Getallproduct()
              toggle()
              setcountryinfo(true)

              validation.resetForm()
            } else {
              setduplicateerro(true)
            }
          })
      } else {
        if (categrid.length != 0) {
          formdata.append("Created_By", localStorage.getItem("UserId"))
          formdata.append("Created_Date", new Date())

          const createoneuser = await axios.instance
            .post("/Insertproduct", formdata, {
              headers: {
                Authorization: tokent,
                "Content-Type": "application/json",
              },
            })
            .then(async res => {
              if (res.data.length === 1) {
                setcoutrysuccess(true)
                Getallproduct()
                validation.resetForm()
                toggle()
              } else {
                setduplicateerro(true)
              }
            })
        } else {
          if (categrid.length === 0) {
            setcategoryerror(true)
          }

          setTimeout(() => {
            setcategoryerror(false)
            setbranderror(false)
            setpriuomderror(false)
            setsecondaryuomerror(false)
          }, 2000)
        }
      }
      setDeleteModal(false)
    },
  })

  const Getallcategory = async () => {
    const get = await axios.instance
      .get("/Getallsubcategory", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        const data = res.data
        const options = data.map(b => ({
          label: b.Category_Description,
          value: b.Category_Id,
        }))
        setallcategorycollections(options)
        setcategoryfilter(res.data)
      })
  }

  const toggle = () => {
    if (modal) {
      setModal(false)
      setcategorydefaultvalue({ label: "Select...", value: "" })
      setbuyerattcheload({ Image: "" })
      setbuyerattchenamte("")
      setbuyerattch(null)
      setUser(null)
      validation.resetForm()
      setallproductslists({
        Product_Details_Description: "",
        Product_Details_Code: "",
        Category_Id: "",
        Rate: "",
        UOM: "",
        Image: "",
        Active: true,
      })
    } else {
      setModal(true)
    }
  }

  const handleUserClick = async arg => {
    const qapara = arg
    setproid(qapara.Product_Details_Id)
    setallproductslists({
      Product_Details_Description: qapara.Product_Details_Description,
      Product_Details_Code: qapara.Product_Details_Code,
      Product_Details_Id: qapara.Product_Details_Id,
      Active: qapara.Active === "Y",
      UOM: qapara.UOM,
      Rate: qapara.Rate,
      Image: qapara.Image,
    })
    setcategrid(qapara.Category_Id)
    setbuyerattcheload(`${qapara.Image}`)
    setprodimages(`https://live.asktek.net/majestic_office_manage_website_api/api/Public/${qapara.Image}`)

    const deleteoneuser = await axios.instance
      .get(`/Getonesubcategory/${qapara.Category_Id}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        for (const data of res.data) {
          setcategorydefaultvalue({
            label: data.Category_Description,
            value: data.Category_Id,
          })
        }
      })
    setIsEdit(true)
    toggle()
  }

  //delete user
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = user => {
    setdeletid(user.Product_Details_Id)
    setDeleteModal(true)
  }

  const handleUserClicks = () => {
    setUserList("")
    setIsEdit(false)
    toggle()
  }

  useEffect(() => {
    Getallproduct()
    Getallcategory()
  }, [])

  const Countrydelete = async () => {
    const deleteoneuser = await axios.instance
      .delete(`/Deleteproduct/${deletid}`, {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        if (res.data === "") {
          Getallproduct()
          setDeleteModal(false)
          setcountryerror(true)
        } else {
          toastr.error("Already Used Cannot be Deleted", "Product")
          setDeleteModal(false)
        }
      })
  }

  const Getallproduct = async () => {
    const get = await axios.instance
      .get("/getallproducts", {
        headers: { Authorization: tokent, "Content-Type": "application/json" },
      })
      .then(res => {
        setallproductscollection(res.data)
      })
  }

  const getcateid = id => {
    setcategrid(id)
  }

  function debugBase64(base64URL) {
    setPoupuimage(base64URL)
    setopen(true)
  }
  const Closepopup = () => {
    setopen(false)
  }

  const columns = useMemo(
    () => [
      {
        Header: "Product Description",
        accessor: "Product_Details_Description",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "UOM",
        accessor: "UOM",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Photo ",
        filterable: false,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            <Link to="#" className="text-body">
              {cellProps.Image != "" ? (
                <img
                  src={`https://live.asktek.net/majestic_office_manage_website_api/api/Public/${cellProps.Image}`}
                  width="50px"
                  height="50px"
                  onClick={() =>
                    debugBase64(
                      `https://live.asktek.net/majestic_office_manage_website_api/api/Public/${cellProps.Image}`
                    )
                  }
                />
              ) : (
                <p>No Image</p>
              )}
            </Link>
          </React.Fragment>
        ),
      },
      {
        Header: "Active",
        accessor: "Active",
        disableFilters: true,
        filterable: true,
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const users = cellProps.row.original
                      handleUserClick(users)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const users = cellProps.row.original
                      onClickDelete(users)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={Countrydelete}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Master" breadcrumbItem="Product Master" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={allproductscollection}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} size="md">
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit Product" : "Add Product"}
            </ModalHeader>
            <ModalBody>
              <Row>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">Description</Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      className="form-control"
                      id="basicpill-firstname-input1"
                      name="Product_Details_Description"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={
                        validation.values.Product_Details_Description || ""
                      }
                      invalid={
                        validation.touched.Product_Details_Description &&
                        validation.errors.Product_Details_Description
                          ? true
                          : false
                      }
                    />
                    {validation.touched.Product_Details_Description &&
                    validation.errors.Product_Details_Description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.Product_Details_Description}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Product Code</Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="Product_Details_Code"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.Product_Details_Code || ""}
                      invalid={
                        validation.touched.Product_Details_Code &&
                        validation.errors.Product_Details_Code
                          ? true
                          : false
                      }
                    />
                    {validation.touched.Product_Details_Code &&
                    validation.errors.Product_Details_Code ? (
                      <FormFeedback type="invalid">
                        {validation.errors.Product_Details_Code}
                      </FormFeedback>
                    ) : null}
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label for="basicpill-lastname-input2">Rate</Label>
                    <Input
                      autoComplete="off"
                      type="number"
                      name="Rate"
                      className="form-control"
                      id="basicpill-lastname-input2"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.Rate || ""}
                      invalid={
                        validation.touched.Rate && validation.errors.Rate
                          ? true
                          : false
                      }
                    />
                  </div>
                </Col>
                <Col lg="6">
                  <div className="mb-3">
                    <Label htmlFor="basicpill-lastname-input3">
                      <b>UOM </b>
                    </Label>
                    <Input
                      autoComplete="off"
                      type="text"
                      name="UOM"
                      className="form-control"
                      id="basicpill-lastname-input3"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.UOM || ""}
                      invalid={
                        validation.touched.UOM && validation.errors.UOM
                          ? true
                          : false
                      }
                    />
                    {validation.touched.UOM && validation.errors.UOM ? (
                      <FormFeedback type="invalid">
                        {validation.errors.UOM}
                      </FormFeedback>
                    ) : null}
                    {/* {uomError ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please select a UOM
                      </p>
                    ) : null} */}
                  </div>
                </Col>
                <Col lg="5">
                  <div className="mb-3">
                    <Label htmlFor="manufacturerbrand">
                      <b>Category </b>
                    </Label>
                    <Select
                      name="CategoryId"
                      options={allcategorycollections}
                      ref={categoryref}
                      classNamePrefix="select2-search-disable"
                      onChange={value => getcateid(value.value)}
                      defaultValue={categorydefaultvalue}
                    />
                    {categoryerror ? (
                      <p style={{ fontSize: "12px" }} className="error">
                        Please Select Category{" "}
                      </p>
                    ) : null}
                  </div>
                </Col>

                <Col lg="5">
                  <div className="mb-3">
                    <Label for="basicpill-address-input1">Product Image</Label>
                    <div
                      onClick={() =>
                        document.getElementById("productimage").click()
                      }
                    >
                      <i
                        className="fas fa-cloud-upload-alt"
                        style={{ cursor: "pointer", fontSize: "30px" }}
                      ></i>
                      <Input
                        id="productimage"
                        name="price"
                        type="file"
                        accept=".png,.jpg,.pdf"
                        onChange={BuyerAttchepack}
                        className="form-control"
                        hidden
                      />
                    </div>
                    {imageError && <p style={{ color: "red" }}>{imageError}</p>}
                  </div>
                  <Col>
                    {isEdit ? (
                      <Link to="#">
                        {typeof prodimages === "string" ? (
                          <img src={prodimages} width="50px" height="50px" />
                        ) : (
                          <img src={buyerattch} width="50px" height="50px" />
                        )}
                      </Link>
                    ) : (
                      <Link to="#">
                        {typeof prodimages === "string" ? (
                          <img
                            src={
                              `https://live.asktek.net/majestic_office_manage_website_api/api/Public/` +
                              prodimages
                            }
                            width="50px"
                            height="50px"
                          />
                        ) : (
                          <img src={buyerattch} width="50px" height="50px" />
                        )}
                      </Link>
                    )}
                  </Col>
                </Col>
                <Col md={12}>
                  <div className="mt-4 mt-md-0">
                    <div className="vstack gap-2">
                      <div className="form-check form-switch form-switch-lg">
                        <Label
                          className="form-check-label"
                          htmlFor="activeSwitch"
                        >
                          Active
                        </Label>
                        <input
                          name="Active"
                          type="checkbox"
                          className="form-check-input"
                          id="activeSwitch"
                          checked={validation.values.Active}
                          onClick={() => {
                            const newActiveState = !validation.values.Active
                            console.log(
                              "Toggling Active state to:",
                              newActiveState
                            )
                            validation.setFieldValue("Active", newActiveState)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <div className="text-end">
                  {!!isEdit ? (
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className="btn btn-success save-user"
                      onClick={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      Add
                    </button>
                  )}
                </div>
              </Row>
            </ModalBody>
          </Modal>
        </div>
      </div>
      {duplicateerro ? (
        <SweetAlert
          title="Product  Already exists "
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          danger
          onConfirm={() => {
            setduplicateerro(false)
          }}
        ></SweetAlert>
      ) : null}

      {coutrysuccess ? (
        <SweetAlert
          title="Product Added Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcoutrysuccess(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryinfo ? (
        <SweetAlert
          title="Product Updated Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryinfo(false)
          }}
        ></SweetAlert>
      ) : null}

      {countryerror ? (
        <SweetAlert
          title="Product Deleted Successfully"
          timeout={2000}
          style={{
            position: "absolute",
            justifyContent: "center",
            alignItems: "center",
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setcountryerror(false)
          }}
        ></SweetAlert>
      ) : null}

      <Backdrop open={dialogbox} className={classes.backdrop}>
        <Spinner name="ball-spin-fade-loader" color="#fafafa" />
      </Backdrop>
      <Dialog
        onClose={Closepopup}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <img src={Poupuimage} style={{ width: "500px", height: "500px" }} />
      </Dialog>
    </React.Fragment>
  )
}
DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
